import { useEffect, useRef } from 'react';
import isEmpty from 'lodash/isEmpty';
import { getSecondsUntilRefresh } from '../utils';
import { getSSOInfo } from './useCredential';

const useUpdateAndFetchRefreshToken = (
  hotelRefreshToken = '',
  fetchRefreshToken
) => {
  const ssoInfo = getSSOInfo();
  const lastRefreshedToken = useRef(null);

  useEffect(() => {
    const accessToken = ssoInfo?.accessToken;
    const tokenToCheck = hotelRefreshToken || accessToken;

    if (!tokenToCheck || isEmpty(ssoInfo)) return;

    // Prevent redundant updates
    if (lastRefreshedToken.current === tokenToCheck) return;

    // Calculate the refresh delay in seconds (default threshold: 5 mins)
    const refreshInSeconds = getSecondsUntilRefresh(tokenToCheck, 4);

    // If refresh time is <= 0 and we haven't refreshed this token yet, refresh immediately
    if (refreshInSeconds <= 0) {
      if (lastRefreshedToken.current !== tokenToCheck) {
        lastRefreshedToken.current = tokenToCheck;
        fetchRefreshToken(tokenToCheck);
      }
      return;
    }

    // Otherwise, set a timeout to refresh when necessary
    const timerId = setTimeout(() => {
      if (lastRefreshedToken.current !== tokenToCheck) {
        lastRefreshedToken.current = tokenToCheck;
        fetchRefreshToken(tokenToCheck);
      }
    }, refreshInSeconds * 1000);

    return () => clearTimeout(timerId);
  }, [hotelRefreshToken, fetchRefreshToken, ssoInfo]);
};

export default useUpdateAndFetchRefreshToken;
